export function getDifferenceArrays(arr1, arr2) {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);

  console.log(arr1, arr2);

  const toDelete = arr1.filter((el) => !set2.has(el));
  const toAdd = arr2.filter((el) => !set1.has(el));
  const ostalo = arr1.filter((el) => set2.has(el));

  return { toDelete, toAdd, ostalo };
}
